var Loader = {
  queue: [],
  current: undefined,
  _script: null,
  head: null,

  loadScript: function (src) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    if (!Loader.head) {
      Loader.head = document.getElementsByTagName('head')[0];
    }
    // defer the loading because IE9 loads in the same frame the script
    // so Loader._script is null
    setTimeout(function () {
      Loader.head.appendChild(script);
    }, 0);
    return script;
  },

  get: function (url, callback) {
    if (!Loader._script) {
      Loader.current = callback;
      Loader._script = Loader.loadScript(url + (~url.indexOf('?') ? '&' : '?') + 'callback=vizjson');
    } else {
      Loader.queue.push([url, callback]);
    }
  },

  getPath: function (file) {
    var scripts = document.getElementsByTagName('script');
    var cartodbJsRe = /\/?cartodb[\-\._]?([\w\-\._]*)\.js\??/;
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      var matches = src.match(cartodbJsRe);

      if (matches) {
        var bits = src.split('/');
        delete bits[bits.length - 1];
        return bits.join('/') + file;
      }
    }
    return null;
  }
};

// Required for jsonp callback, see Loader.get()
window.vizjson = function (data) {
  Loader.current && Loader.current(data);
  // remove script
  Loader.head.removeChild(Loader._script);
  Loader._script = null;
  // next element
  var a = Loader.queue.shift();
  if (a) {
    Loader.get(a[0], a[1]);
  }
};

module.exports = Loader;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/core/loader.js
// module id = 1617
// module chunks = 6